import { render, staticRenderFns } from "./ComplaintGroupDetailList.vue?vue&type=template&id=8e2f6e4e&"
import script from "./ComplaintGroupDetailList.vue?vue&type=script&lang=js&"
export * from "./ComplaintGroupDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports